import styled from 'styled-components';

const Table = styled.div`
  margin-top: 3rem;
`;

export function TableContainer({ children }) {
  return <Table>{children}</Table>;
}
